<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <label class="opt-img">
        <img v-if="item.config.image" class="thumb" :src="item.config.image" alt="">
        <span v-else>عکس</span>
        <input @change="uploadImage" type="file">
      </label>
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import FormGroup from "@/plugin/components/validator/FormGroup.vue";
import FormErrorsManager from "@/plugin/components/validator/FormErrorsManager.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "ImageInput",
  components: {FormErrorsManager, FormGroup},
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    },
    async checkFormImageDirectory() {
      let req = await this.$store.dispatch('FileManager/setDirectories')
      let folders = req.data.data
      if (folders.indexOf('form-images') > -1) {
        return true
      }

      return false

    },
    async createFolder() {
      let checker = await this.checkFormImageDirectory()

      if (checker == false) { // create folder if not exists
        let form = {
          name: 'form-images'
        }
        let req = await this.$store.dispatch('FileManager/createDirectory', form)
      }
      return true
    },
    async uploadImage(e) {
      await this.createFolder()
      const file = e.target.files[0];

      let form = {
        uploadDirectory: 'form-images',
        selectedFiles: [file],
      }

      let req = await this.$store.dispatch('FileManager/uploadFiles', form)
      this.item.config.image = req.data.data[0]['file']


    },
  }
}
</script>

<style scoped>
.item-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.item-head .form-control {
  flex: 0 0 200px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
}
.opt-img {
  width: 40px;
  height: 28px;
  border: 1px dashed #ddd;
  border-radius: 6px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0;
  cursor: pointer;
}
.opt-img input {
  display: none;
}
.thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>